export default "/list/static/images/visibility_off.png";